"use strict";
// SPDX-FileCopyrightText: 2024 Red Bee Media Ltd <https://www.redbeemedia.com/>
//
// SPDX-License-Identifier: MIT
Object.defineProperty(exports, "__esModule", { value: true });
exports.error = exports.warn = exports.info = exports.debug = exports.setLogLevel = void 0;
const js_player_shared_1 = require("@ericssonbroadcastservices/js-player-shared");
const logger = new js_player_shared_1.Logger({
    prefix: "[PlayerCore]",
});
function setLogLevel(logLevel) {
    logger.setLogLevel(logLevel);
}
exports.setLogLevel = setLogLevel;
function debug(...args) {
    logger.debug(...args);
}
exports.debug = debug;
function info(...args) {
    logger.info(...args);
}
exports.info = info;
function warn(...args) {
    logger.warn(...args);
}
exports.warn = warn;
function error(...args) {
    logger.error(...args);
}
exports.error = error;
//# sourceMappingURL=logger.js.map